import { Box } from '@mui/material'
import style from './Modal.module.css'
import EventPillStyle from './diaryView.module.css'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Header } from '../../components/header/Header'
import close from '../../assets/articles/delete.svg'
import { Event as E } from '../../modules/calendar/models/Event'
import { dateToDateString, dateToTimeWithoutSecondsString } from '../../common/utils/date'
import { AppButton, ButtonTheme } from '../../components/app-button/AppButton'
import { getUserContainer } from '../../container/user-module'
import { IUserService, LOGGED_USER_SERVICE_KEY, USER_SERVICE_KEY } from '../../modules/users'
import { LoggedUserService } from '../../modules/users/services/LoggedUserService'
import { Tooltip } from '@mui/material'
import reviewIcon from '../../assets/events_icons/bola-revision.svg'
import dateIcon from '../../assets/calendar/cita.svg'
import vaccineIcon from '../../assets/events_icons/bola-vacunas.svg'
import adviceIcon from '../../assets/events_icons/bola-consejos.svg'
import landmarkIcon from '../../assets/events_icons/bola-hitos.svg'
import trainingIcon from '../../assets/calendar/ejercicio.svg'
import formIcon from '../../assets/events_icons/evento-formulario.svg'
import othersIcon from '../../assets/events_icons/bola-otros.svg'
import medicationIcon from '../../assets/dashboard/treatmentIconEvent.svg'
import { Link } from 'react-router-dom'
import { forkJoin } from 'rxjs'
import { Observable } from 'rxjs'
import { User } from '../../modules/users/models/User'
import { File as F } from '../../modules/files/models/File'
import { EventCategory, eventCategoryTypes } from '../../modules/calendar/enums/EventCategory'
import dayjs from 'dayjs'

const userService = getUserContainer().get<IUserService>(USER_SERVICE_KEY)
const loggedUserService = getUserContainer().get<LoggedUserService>(LOGGED_USER_SERVICE_KEY)
const eventCategories = eventCategoryTypes()

type CalendarModalProps = {
  handleClose: () => void
  handlerEventClick: (event: E) => void
  setOpenModal: (boolean: boolean) => void
  events: E[]
  date: Date | string
  hour: string
}

type WeekEvent = {
  event: E
}

export const CalendarModalMultiEvents = (props: CalendarModalProps) => {
  const { t } = useTranslation()
  const loggedUser = loggedUserService.get()
  const [filteredEvents, setFilteredEvents] = useState<E[]>([])
  const [users, setUsers] = useState<Map<string, User>>(new Map())
  const [fileNames, setFileNames] = useState<Map<string, string>>(new Map())

  const getUsers = (ids: string[]): Observable<User[]> =>
    forkJoin(ids.map((uid) => userService.getByID(uid)) as unknown) as Observable<User[]>

  const filterEventsByDayAndHour = (events: E[], date: Date | string, hour: string): E[] => {
    const hourString = hour.split(':')[0]

    return events.filter((event) => {
      const isSameDayEvent =
        date === dayjs(event.startDate).format('DD') &&
        dayjs(event.startDate).format('DD') === dayjs(event.finishDate).format('DD') &&
        dayjs(event.startDate).format('HH') === hourString

      const isMultiDayEventStart =
        date === dayjs(event.startDate).format('DD') &&
        dayjs(event.startDate).format('DD') !== dayjs(event.finishDate).format('DD') &&
        dayjs(event.startDate).format('HH') === hourString

      return isSameDayEvent || isMultiDayEventStart
    })
  }

  const handlerClick = (event: E) => {
    props.handlerEventClick(event)
    props.handleClose()
    props.setOpenModal(true)
  }

  const getIcon = (type: EventCategory) => {
    switch (type) {
      case EventCategory.Reviews:
        return (
          <Tooltip title={t('reviews') || 'reviews'}>
            <img src={reviewIcon} alt={'reviews'} />
          </Tooltip>
        )

      case EventCategory.Medication:
        return (
          <Tooltip title={t('treatment') || 'treatment'}>
            <img src={medicationIcon} alt={'treatment'} />
          </Tooltip>
        )

      case EventCategory.Vaccines:
        return (
          <Tooltip title={t('vaccine') || 'vaccine'}>
            <img src={vaccineIcon} alt={'vaccine'} />
          </Tooltip>
        )

      case EventCategory.Appointment:
        return (
          <Tooltip title={t('medicalappointment') || 'medicalappointment'}>
            <img src={dateIcon} alt={'medicalappointment'} />
          </Tooltip>
        )

      case EventCategory.Advices:
        return (
          <Tooltip title={t('advices') || 'advices'}>
            <img src={adviceIcon} alt={'advices'} />
          </Tooltip>
        )

      case EventCategory.Landmarks:
        return (
          <Tooltip title={t('landmarks') || 'landmarks'}>
            <img src={landmarkIcon} alt={'landmarks'} />
          </Tooltip>
        )

      case EventCategory.Training:
        return (
          <Tooltip title={t('training') || 'training'}>
            <img src={trainingIcon} alt={'training'} />
          </Tooltip>
        )
      case EventCategory.Forms:
        return (
          <Tooltip title={t('form') || 'form'}>
            <img src={formIcon} alt={'training'} />
          </Tooltip>
        )

      default:
        return (
          <Tooltip title={t('others') || 'others'}>
            <img src={othersIcon} alt={'others'} />
          </Tooltip>
        )
    }
  }

  const getColorByCategory = (category: number) => {
    let color

    switch (category) {
      case 1:
        color = '#B4CBC5'
        break
      case 2:
        color = '#2E7161'
        break
      case 3:
        color = '#d2617e'
        break
      case 4:
        color = '#eadf33'
        break
      case 5:
        color = '#3fbfcc'
        break
      case 6:
        color = '#B4CBC5'
        break
      case 7:
        color = '#815abb'
        break
      case 8:
        color = '#9b8c58'
        break
      default:
        color = '#959595'
        break
    }
    return color
  }

  function DiaryEvent2(weekEvent: WeekEvent): JSX.Element {
    let duration
    if (
      dayjs(weekEvent.event.finishDate).format('DD').toString() ===
      dayjs(weekEvent.event.startDate).format('DD').toString()
    ) {
      duration =
        Number(dayjs(weekEvent.event.finishDate).format('HH')) -
        Number(dayjs(weekEvent.event.startDate).format('HH'))
    }

    return (
      <>
        {weekEvent.event.startDate.getHours() === weekEvent.event.finishDate.getHours() ? (
          <Box
            className={EventPillStyle.eventNotSameDay}
            onClick={() => handlerClick(weekEvent.event)}
            style={{
              backgroundColor: getColorByCategory(weekEvent.event.eventCategory),
            }}
          >
            <div className={EventPillStyle.iconEventCategoryNotSameDay}>
              {getIcon(weekEvent.event.eventCategory)}
            </div>
            <h3 className={EventPillStyle.eventTitleNotSameDay}>
              {dayjs.utc(weekEvent.event.startDate).format('HH:mm') + ' ' + weekEvent.event.title}
            </h3>
          </Box>
        ) : (
          <Box
            className={EventPillStyle.event}
            onClick={() => handlerClick(weekEvent.event)}
            style={{
              ['--duration-height' as any]: duration,
              ['--col' as any]: getColorByCategory(weekEvent.event.eventCategory),
              backgroundColor: getColorByCategory(weekEvent.event.eventCategory),
            }}
          >
            <div className={EventPillStyle.iconEventCategory}>
              {getIcon(weekEvent.event.eventCategory)}
            </div>
            <h3 className={EventPillStyle.eventTitle}>
              {dayjs(weekEvent.event.startDate).format('HH:mm') + ' ' + weekEvent.event.title}
            </h3>
          </Box>
        )}
      </>
    )
  }

  useEffect(() => {
    const filtered = filterEventsByDayAndHour(props.events, props.date, props.hour)
    console.log('PROPS: ', props)
    console.log('FILTERED: ', filtered)
    setFilteredEvents(filtered)
  }, [props.events, props.date, props.hour])

  return (
    <>
      <Box className={style.modalView}>
        <Header
          label={t('eventsFor') + ' ' + dayjs(props.date).format('DD/MM/YYYY') + ' ' + props.hour}
          icon={close}
          onClick={props.handleClose}
        />

        <Box className={style.eventsContainer}>
          {filteredEvents.length > 0 ? (
            filteredEvents.map((event) => (
              <Box key={event.id} className={style.eventItem}>
                <DiaryEvent2 event={event} key={event.id} />
              </Box>
            ))
          ) : (
            <Box className={style.noEvents}>
              <p>{t('noEventsDiary')}</p>
            </Box>
          )}
        </Box>
      </Box>
    </>
  )
}
